import { lerpColor } from '../../color';
import { hsl, type World } from '../../world';
import { dress, fx } from './dress';
import { paint } from './paint';
import './world.css';

const H = 340;
const S = 36;
const A1 = 175;
const A2 = 50;

const L = hsl(H, 72, 82);
const HELD = hsl(A1, 88, 78);
const SPOT = hsl(A2, 85, 76);
const RIM = hsl(H, 45, 92);

const world: World = {
  id: 'doces',
  name: 'Doces',
  seed: 'doces',
  legacy: false,
  hue: H,
  ceil: 0x5c3340,
  font: 'Cherry Bomb One',
  fontFile: 'cherry-bomb-one-400.woff2',
  fontWeight: '400',
  fontLicense: 'OFL-1.1',
  dark: true,
  boil: false,
  glow: 'add',
  glowAlpha: 0.4,
  fillAlpha: 0.72,
  palette: {
    bg: hsl(H, S, 10),
    ink: hsl(H, S + 12, 5),
    rim: RIM,
    held: HELD,
    heldShade: hsl(A1, 60, 60),
    heldLight: hsl(A1, 90, 90),
    incoming: { circle: L, square: SPOT, triangle: lerpColor(L, HELD, 0.5), hex: lerpColor(L, SPOT, 0.5) },
    spot: SPOT,
    path: hsl(H, 30, 72),
    text: hsl(H, 40, 94),
    sparks: [HELD, SPOT, L, RIM],
  },
  burst: { count: 12, speed: 0.55, drag: 3.2, gravity: 0.35, spin: 5, life: 0.9, sizeMin: 0.009, sizeMax: 0.02 },
  dress,
  fx,
  paint,
};

export default world;
